const testimonials = [
  {
    id: 1,
    name: 'Lucas Silva',
    avatar: 'https://public.readdy.ai/ai/img_res/74d7c4a5da4e532e9e470ab1621ace1d.jpg',
    rating: 5,
    comment: 'Melhor loja de hardware! Comprei minha RTX 4090 aqui e o atendimento foi impecável. Entrega rápida e produto original.',
    date: '15 de Janeiro, 2024'
  },
  {
    id: 2,
    name: 'Mariana Costa',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20gamer%20avatar%20portrait%20young%20woman%20headshot%20realistic%20photo%20gaming%20setup%20background&width=100&height=100&seq=testimonial2&orientation=squarish',
    rating: 5,
    comment: 'Montei meu PC gamer completo aqui. A equipe me ajudou a escolher as melhores peças dentro do meu orçamento. Recomendo!',
    date: '10 de Janeiro, 2024'
  },
  {
    id: 3,
    name: 'Rafael Oliveira',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20gamer%20avatar%20portrait%20young%20man%20headshot%20realistic%20photo%20gaming%20setup%20background&width=100&height=100&seq=testimonial3&orientation=squarish',
    rating: 5,
    comment: 'Preços justos e produtos de qualidade. Já fiz várias compras e nunca tive problemas. Site muito bom!',
    date: '5 de Janeiro, 2024'
  },
  {
    id: 4,
    name: 'Amanda Santos',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20gamer%20avatar%20portrait%20young%20woman%20headshot%20realistic%20photo%20gaming%20setup%20background&width=100&height=100&seq=testimonial4&orientation=squarish',
    rating: 5,
    comment: 'Excelente experiência de compra! Recebi meu processador Ryzen 9 em perfeito estado. Voltarei a comprar com certeza.',
    date: '28 de Dezembro, 2023'
  }
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            O Que Nossos <span className="bg-gradient-to-r from-neon-pink to-neon-cyan bg-clip-text text-transparent">Clientes</span> Dizem
          </h2>
          <p className="text-gray-400 text-lg">
            Avaliações reais de quem já comprou conosco
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-gray-900 rounded-lg p-6 border border-gray-800 hover:border-neon-pink hover:shadow-neon-pink transition-all"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full rounded-full object-cover border-2 border-neon-cyan"
                  />
                </div>
                <div className="ml-3">
                  <h4 className="font-semibold text-white">{testimonial.name}</h4>
                  <div className="flex items-center">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-neon-green text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-300 text-sm mb-3">{testimonial.comment}</p>
              <p className="text-xs text-gray-500">{testimonial.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
